export default __webpack_public_path__ + "static/media/add-leave-fab-button.f36beb89.svg";